export enum StatusType {
  success = 'success',
  warning = 'warning',
  error = 'error'
}
